import React, { useState } from 'react';
import { 
  PhoneIcon, 
  EnvelopeIcon, 
  MapPinIcon 
} from '@heroicons/react/24/outline';
import { FaWhatsapp } from 'react-icons/fa';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const mailtoLink = `mailto:service@ayelmarine.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(
      `Name: ${formData.name}
Email: ${formData.email}

Message:
${formData.message}`
    )}`;

    window.location.href = mailtoLink;
  };

  const contactInfo = [
    {
      title: "Phone",
      details: [
        "+90 216 888 81 69",
        <a 
          href="https://wa.me/905522065415" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center space-x-2 hover:text-marine-red transition-colors duration-300"
        >
          <FaWhatsapp className="inline-block" />
          <span>+90 552 206 54 15</span>
        </a>
      ],
      icon: PhoneIcon
    },
    {
      title: "Email",
      details: [
        <a href="mailto:info@ayelmarine.com" className="text-marine-red hover:underline">info@ayelmarine.com</a>,
        <a href="mailto:sales@ayelmarine.com" className="text-marine-red hover:underline">sales@ayelmarine.com</a>,
        <a href="mailto:service@ayelmarine.com" className="text-marine-red hover:underline">service@ayelmarine.com</a>
      ],
      icon: EnvelopeIcon
    },
    {
      title: "Address",
      details: [
        "Yayla Mahallesi, Pınar Sokak",
        "No:5/A, 34944",
        "Tuzla/İSTANBUL"
      ],
      icon: MapPinIcon
    }
  ];

  return (
    <div className="pt-20 font-tt-lakes">
      
      <div className="bg-marine-black text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Contact Us
            </h1>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Get in touch with us for any inquiries about our services
            </p>
          </div>
        </div>
      </div>

      
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            {contactInfo.map((info, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mr-4">
                    <info.icon className="w-6 h-6 text-marine-red" />
                  </div>
                  <h3 className="text-xl font-bold text-marine-black">
                    {info.title}
                  </h3>
                </div>
                <div className="space-y-2">
                  {info.details.map((detail, idx) => (
                    <p key={idx} className="text-gray-600">
                      {detail}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      
      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <iframe
              title="Ayel Marine Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d188.6720527000004!2d29.310267940917758!3d40.83339216955785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cadd0008516d6d%3A0xdb2c655997b955a5!2zQVlFTE1BUsSwTkUgR0VNxLAgRUxFS1RST07EsEs!5e0!3m2!1str!2str!4v1734354732185!5m2!1str!2str"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>

     
      <div className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-2xl font-bold text-marine-black mb-6">
              Send us a message
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-marine-red focus:border-marine-red"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-marine-red focus:border-marine-red"
                    required
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-marine-red focus:border-marine-red"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Message
                </label>
                <textarea
                  rows="4"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-marine-red focus:border-marine-red"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-marine-red hover:bg-red-700 text-white py-3 rounded-lg transition-colors duration-300"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
